var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      pug_mixins["contact"] = pug_interp = function(prefix){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!prefix) {
prefix=''
}
pug_html = pug_html + "\u003Cdiv class=\"box contact\"\u003E\u003Cdiv class=\"title\"\u003EIhr Ansprechpartner\u003C\u002Fdiv\u003E\u003Cdiv class=\"main text-center\"\u003E\u003Cdiv class=\"detail\"\u003E\u003Cfigure class=\"avatar\"\u003E\u003Cdiv class=\"picture\"\u003E\u003Cimg" + (" class=\"image\""+pug.attr("ng-src", '/assets/img/advisors/{{ '+prefix+'advisorDetails.id }}.jpg', true, true)+" onerror=\"this.src=&quot;\u002Fassets\u002Fimg\u002Fadvisors\u002Ffallback.jpg&quot;\" onabort=\"this.src=&quot;\u002Fassets\u002Fimg\u002Fadvisors\u002Ffallback.jpg&quot;\"") + "\u003E\u003C\u002Fdiv\u003E\u003Cfigcaption class=\"name\"\u003E" + (pug.escape(null == (pug_interp = '{{ '+prefix+'advisorDetails.firstname }} {{ '+prefix+'advisorDetails.name }}') ? "" : pug_interp)) + "\u003C\u002Ffigcaption\u003E\u003C\u002Ffigure\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail email\"\u003E\u003Ci class=\"font-icon font-icon-alt icon-email\"\u003E\u003C\u002Fi\u003E\u003Cspan class=\"key\"\u003E\u003Ca" + (pug.attr("ng-href", 'mailto:{{ '+prefix+'advisorDetails.email }}', true, true)) + "\u003E" + (pug.escape(null == (pug_interp = '{{ '+prefix+'advisorDetails.email }}') ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"detail phone\" ng-if=\"advisorDetails.phone_support\"\u003E\u003Ci class=\"font-icon font-icon-alt icon-telephone\"\u003E\u003C\u002Fi\u003E\u003Cspan class=\"key\"\u003E\u003Ca" + (pug.attr("ng-href", 'tel:+{{ '+prefix+'advisorDetails.phone_support }}', true, true)) + "\u003E" + (pug.escape(null == (pug_interp = '{{ '+prefix+'advisorDetails.phone_support }}') ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + ("\u003Csection class=\"arbeitnehmer\" id=\"dashboard-box\"\u003E\u003Carticle class=\"section-bg\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"xsmall-12 medium-7 large-6 columns\"\u003E\u003Cdiv class=\"panel semitransparent\"\u003E\u003Ch2\u003E{{configuration.dashboard_config.dashboard_headline_config.is_enabled ? configuration.dashboard_config.dashboard_headline_config.dashboard_headline : configuration.dashboard_config.dashboard_headline_config.default_dashboard_headline }}\u003C\u002Fh2\u003E\u003Ch3\u003E{{configuration.dashboard_config.dashboard_headline_config.is_enabled ? configuration.dashboard_config.dashboard_headline_config.dashboard_subheadline : configuration.dashboard_config.dashboard_headline_config.default_dashboard_subheadline }}\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv id=\"main-view\"\u003E" + (null == (pug_interp = require("./modules/_external_notification.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_car_leasing_notification.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_yearly_notification.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_missingDocuments.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_neo_status_change_notification.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_approval_process_notifications.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_basket_control_process_success_notifications.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_mpp_decision_process_notification.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_basket_begin_change_notification.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_bonus_change_begin_date_notification.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_bonus_bikeleasing_confirmation_notification.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_dticket_notifications.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_cashback_notifications.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_bonus_control_process_notification.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_bonus_notification.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_missing_evg_documents_notification.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_welcomeBlock.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_checkoutSession.pug").call(this, locals)) ? "" : pug_interp));
pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};































































pug_mixins["switchbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["double-label-switch",attributes.containerHtmlClass], [false,false]), false, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"switch round large\"\u003E\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+" type=\"checkbox\""+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("id", id, true, true)+pug.attr("name", id, true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-true-value", attributes['ng-true-value'], true, true)+pug.attr("ng-init", attributes['ng-init'], true, true)+pug.attr("ng-false-value", attributes['ng-false-value'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E\u003Clabel" + (" class=\"switch__label\""+pug.attr("for", id, true, true)) + "\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};






































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};
pug_mixins["select"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.attributes) {
attributes.attributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "form-group"},attributes.groupAttributes]), true)) + "\u003E\u003Clabel" + (" class=\"control-label\""+pug.attr("for", attributes.key, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E\u003Cselect" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"name": pug.escape(id),"id": pug.escape(id),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"disabled": pug.escape(attributes.disabled),"required": pug.escape(attributes.required),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
if (attributes.titleMap) {
// iterate attributes.titleMap
;(function(){
  var $$obj = attributes.titleMap;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
    }
  }
}).call(this);

}
block && block();
pug_html = pug_html + "\u003C\u002Fselect\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"calc-panel bigbox\" ng-if=\"showSteuerfreiExtrasComponents\"\u003E\u003Ch3\u003EPrüfen Sie Ihr Einsparpotenzial\u003C\u002Fh3\u003E\u003Cbr\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"row use-gutter\"\u003E\u003Cdiv class=\"columns xsmall-12 small-12 medium-8 large-4\"\u003E\u003Cdiv class=\"row use-gutter\"\u003E\u003Cdiv class=\"columns xsmall-12 small-6 medium-6 large-6\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "employee.data.parameters.brutto","title": "Bruttogehalt","required": pug.escape(true),"readonly": "saving","validationMessages": {"required":"Bitte geben Sie Ihr Bruttogehalt ein"},"attributes": {"vn-currency":"true"},"data-cy": "vn.configuration.employeeDashboard.neoAdvantage.inputSalary"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns xsmall-12 small-6 medium-6 large-6\"\u003E";
pug_mixins["select"].call({
attributes: {"key": "employee.data.parameters.pap_stkl","title": "Steuerklasse","required": pug.escape(true),"readonly": "saving","data-cy": "vn.configuration.employeeDashboard.neoAdvantage.selectTaxClass","validationMessages": {"required":"Geben Sie Ihre Steuerklasse an"},"attributes": {"ng-options":"stkl.value as stkl.name for stkl in steuerklassen"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row use-gutter\"\u003E\u003Cdiv class=\"columns xsmall-12 small-6 medium-6 large-6\"\u003E\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"birthdateInput\" date-refocus=\"true\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "employee.data.parameters.geburtsdatum","title": "Geburtsdatum","required": pug.escape(true),"readonly": "saving","data-cy": "vn.configuration.employeeDashboard.neoAdvantage.inputBirthDate","attributes": {"vn-date":"true","vn-date-reformat":"true","vn-date-string-model":"true","vn-date-year-range":"true","vn-date-age-min":14,"vn-date-age-max":90,"ng-model-options":"{allowInvalid: true}","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F"},"fieldHtmlClass": "birthdateInput","validationMessages": {"required":"Bitte Geburtsdatum angeben","parse":"Bitte Geburtsdatum im Format tt.mm.jjjj eingeben","age":"Bitte überprüfen Sie die Eingabe"}}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns xsmall-12 small-6 medium-6 large-6\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"key": "employee.data.parameters.pap_r","title": "Kirchensteuer","readonly": "saving","data-cy": "vn.configuration.employeeDashboard.neoAdvantage.checkChurchTax"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns xsmall-12 small-6 medium-4 large-2\"\u003E\u003Cinput class=\"button button-primary\" type=\"submit\" form=\"potentialForm\" value=\"Jetzt berechnen\" ng-disabled=\"saving\" data-cy=\"vn.configuration.employeeDashboard.neoAdvantage.buttonCalculateAdvantage\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"name": "potentialForm","id": "potentialForm","ng-submit": "calculate(potentialForm)"}
});
pug_html = pug_html + "\u003Cdiv class=\"row hl\" ng-class=\"{hidden: !potential}\"\u003E\u003Cdiv class=\"xsmall-12 small-3 medium-3 large-3 columns resultLabel\"\u003E\u003Cspan\u003EIhr Ergebnis:\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"xsmall-12 small-9 medium-5 large-5 columns resultValue\"\u003E\u003Cspan\u003EBis zu" + (pug.escape(null == (pug_interp = ' ') ? "" : pug_interp)) + "\u003Cstrong\u003E{{ potential | currency }} pro Jahr\u003C\u002Fstrong\u003E möglich\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"medium-4 large-4 columns go\" ng-click=\"start()\" data-cy=\"vn.configuration.employeeDashboard.neoAdvantage.buttonStartPreCheckout\"\u003E\u003Cspan\u003ELOS GEHT'S!\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Carticle class=\"bigbox\" ng-if=\"$ctrl.dashboardOfferNotification\"\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"quill-editor no-border\"\u003E\u003Cng-quill-editor class=\"quill-content\" id=\"allgemein-content-mein-akte\" ng-model=\"$ctrl.dashboardOfferNotification['text']\" read-only=\"true\" theme=\"snow\" modules=\"{toolbar:false}\"\u003E\u003C\u002Fng-quill-editor\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"right\" overlay=\"$ctrl.loading\" style=\"width:100%;margin-bottom:15px\"\u003E\u003Cbutton class=\"button right go\" ng-click=\"$ctrl.goToIncentPortal()\" style=\"margin:0\"\u003ERabatt-Welt\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Farticle\u003E" + (null == (pug_interp = require("./modules/_components.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_cms.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_cashbackVersicherungVorsorge.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./modules/_shop.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv id=\"side-view\" fixonheader\u003E";
pug_mixins["contact"]();
pug_html = pug_html + ("\u003Cdiv class=\"box actions\"\u003E\u003Cdiv class=\"title\"\u003EAktionen\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Ca class=\"button button-primary\" href=\"\u002Fmeineakte\u002Fuebersicht\"\u003E\u003Ci class=\"font-icon icon-user\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EMeine Akte\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"button button-primary\" ng-if=\"iAmEmployer\" ui-sref=\"inApp.cockpit.kundenauswahl\"\u003E\u003Ci class=\"font-icon icon-user\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ECockpit\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"button button-primary\" ui-sref=\"inApp.bonus.approvals\" ng-if=\"iAmApprover\"\u003E\u003Ci class=\"font-icon icon-user\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EFreigabeassistent\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Ca class=\"button button_primary\" ng-click=\"menu.openSupportDialog()\"\u003E\u003Ci class=\"font-icon icon-user\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003ESupport kontaktieren\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"box video-container\" ng-if=\"configuration.dashboard_config.dashboard_video_config.is_enabled\"\u003E\u003Cdiv class=\"title\"\u003EDas ValueNet Portal\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"video\"\u003E\u003Ciframe src=\"https:\u002F\u002Fplayer.vimeo.com\u002Fvideo\u002F397980824?dnt=1\" webkitallowfullscreen mozallowfullscreen allowfullscreen\u003E\u003C\u002Fiframe\u003E\u003Ca class=\"video-link\" href=\"https:\u002F\u002Fplayer.vimeo.com\u002Fvideo\u002F397980824?dnt=1\" magnific-popup=\"{type: &quot;iframe&quot;, clicker: clicker}\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E" + (null == (pug_interp = require("../../../helpers/_footer.pug").call(this, locals)) ? "" : pug_interp));
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;